export default "__VITE_ASSET__B0xAka46__"